import { forwardRef } from "react";
import { Typography, ITypographyProps } from "../Typography";

export interface IH2Props extends Omit<ITypographyProps, "as" | "variant"> {}

export const H2 = forwardRef<HTMLHeadingElement, IH2Props>((props, ref) => {
  return <Typography ref={ref} as="h2" variant="h2" {...props} />;
});

H2.displayName = "H2";
